:host {
  display: block;
}

@media screen and (min-width: 980px) {
  .products-list__list {
    display: block;
  }
}

.products-list__title {
  color: #333333;
  margin: 0;
  font-weight: normal;
  font-size: 1.125rem;
  line-height: 1.5625rem;
}

@media screen and (min-width: 980px) {
  .products-list__title {
    font-size: 1.375rem;
    line-height: 1.875rem;
  }
}

.products-list__count {
  color: #9fa0a4;
}